import { useMemo, useState } from "react"

import { APIS } from "../../../config/apis"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { postTempFile } from "../../../utils/requests"
import { ServerRequest } from "../../../utils/apiweb"
import {TIPS} from "../../../consts/tips";

import { FormError, FormLabel, InputFile, InputLista, Modal } from "../../common"
import { useFormErrors, useManagedContext } from "../../hooks"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const EXTENSION_POR_TIPO_ARCHIVO = {
    SUATS: ".txt",
    ARBA_VEHICULO: ".txt",
    ARBA_CATASTRO: ".txt",
    TRANSFERENCIAS: ".csv",
    VALUACIONES_MTM: ".csv",
}

const ImportadorModal = ({ close }) => {
    const { setIsLoading } = useManagedContext()

    const [tipoArchivo, setTipoArchivo] = useState()
    const [tipoDatosArba, setTipoDatosArba] = useState()
    const [file1, setFile1] = useState()
    const [file2, setFile2] = useState()
    const [file3, setFile3] = useState()
    const [file4, setFile4] = useState()

    const isTipoArchivoArbaVehiculo = useMemo(() => tipoArchivo?.codigo === "ARBA_VEHICULO", [tipoArchivo?.codigo]) //ARBA Vehiculos

    const extensionEsperada = EXTENSION_POR_TIPO_ARCHIVO[tipoArchivo?.codigo]
    const isExtensionValida = (file) => !file || !extensionEsperada || file.name.toLowerCase().endsWith(extensionEsperada)

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    function getErrors() {
        const errors = {}

        if (!tipoArchivo) errors.idTipoArchivoImportacion = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (!file1) errors.archivo1 = VALIDATION_MESSAGE.REQUIRED
        if (isTipoArchivoArbaVehiculo) {
            if (!file2) errors.archivo2 = VALIDATION_MESSAGE.REQUIRED
            if (!file3) errors.archivo3 = VALIDATION_MESSAGE.REQUIRED
            if (!file4) errors.archivo4 = VALIDATION_MESSAGE.REQUIRED
        }

        return errors
    }

    function getFormatErrors() {
        const errors = {}

        const mensaje = `Formato de archivo inválido, se espera uno de extensión ${extensionEsperada}`
        if (!isExtensionValida(file1)) errors.archivo1 = mensaje
        if (isTipoArchivoArbaVehiculo) {
            if (!isExtensionValida(file2)) errors.archivo2 = mensaje
            if (!isExtensionValida(file3)) errors.archivo3 = mensaje
            if (!isExtensionValida(file4)) errors.archivo4 = mensaje
        }

        return errors
    }

    const onAccept = async () => {

        if (!validate()) return

        const callbackNoSuccess = (response) => {
            response.json()
            .then((error) => {
              const message = error.message;
              ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
              setIsLoading(false);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false);
            });
        }
        const callbackError = (error) => {
            const message = 'Error procesando solicitud: ' + error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setIsLoading(false)
        }
        const callbackSuccess = (response) => {
            response.json()
            .then((id) => {
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'El proceso se inició correctamente')
                setIsLoading(false)
                close()
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };

        setIsLoading(true)
        
        const path1 = await postTempFile(file1.data);
        let path2 = null;
        let path3 = null;
        let path4 = null;
        if (isTipoArchivoArbaVehiculo) {
            path2 = await postTempFile(file2.data);
            path3 = await postTempFile(file3.data);
            path4 = await postTempFile(file4.data);
        }

        let body = {};
        if (isTipoArchivoArbaVehiculo) {
            body["formalPath"] = path1;
            body["propietariosPath"] = path2;
            body["denunciasPath"] = path3;
            body["deudasPath"] = path4;
            body["formalName"] = file1.name;
            body["propietariosName"] = file2.name;
            body["denunciasName"] = file3.name;
            body["deudasName"] = file4.name;
        }
        else {
            body["path"] = path1;
            body["name"] = file1.name;
        }

        const paramsUrl = `/async/${tipoArchivo.codigo}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.IMPORTADOR,
            paramsUrl,
            body,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
        <Modal
            onEscape={() => close()}
            show
            title="Importaciones"
            tipName={TIPS.NAME.MODALS.IMPORTADOR_MODAL}
            body={(
                <div className='row form-basic'>

                    <div className="col-12 col-md-6">
                        <FormLabel htmlFor="idTipoArchivoImportacion" required>Tipo de archivo</FormLabel>
                        <InputLista
                            name="idTipoArchivoImportacion"
                            placeholder=""
                            className={`form-control ${errorOf('idTipoArchivoImportacion') ? 'is-invalid' : ''}`}
                            value={tipoArchivo?.id ?? 0}
                            onChange={({ target: { row }}) => setTipoArchivo(row)}
                            disabled={false}
                            lista="TipoArchivoImportacion"
                            filter={(row) => row.id !== 131} //FILTRO SUGIT
                        />
                        <FormError message={errorOf('idTipoArchivoImportacion')} />
                    </div>

                    <div className="col-12 col-md-6">
                        <FormLabel htmlFor="archivo1" required>Archivo de importación</FormLabel>
                        <InputFile
                            name="archivo1"
                            type="text"
                            placeholder="Click para adjuntar un archivo..."
                            className={`form-control ${errorOf('archivo1') ? 'is-invalid' : ''}`}
                            value={file1?.name ?? ''}
                            onUpload={(name, data) => setFile1({ name, data })}
                        />
                        <FormError message={errorOf('archivo1')} />
                    </div>
                    {isTipoArchivoArbaVehiculo &&
                    <>
                    <div className="col-12 col-md-6">
                        <FormLabel htmlFor="archivo2" required={isTipoArchivoArbaVehiculo}>Archivo anexo de propietarios</FormLabel>
                        <InputFile
                            name="archivo2"
                            type="text"
                            placeholder="Click para adjuntar un archivo..."
                            className={`form-control ${errorOf('archivo2') ? 'is-invalid' : ''}`}
                            value={file2?.name ?? ''}
                            onUpload={(name, data) => setFile2({ name, data })}
                        />
                        <FormError message={errorOf('archivo2')} />
                    </div>
                    <div className="col-12 col-md-6">
                        <FormLabel htmlFor="archivo3" required={isTipoArchivoArbaVehiculo}>Archivo anexo de denuncias</FormLabel>
                        <InputFile
                            name="archivo3"
                            type="text"
                            placeholder="Click para adjuntar un archivo..."
                            className={`form-control ${errorOf('archivo3') ? 'is-invalid' : ''}`}
                            value={file3?.name ?? ''}
                            onUpload={(name, data) => setFile3({ name, data })}
                        />
                        <FormError message={errorOf('archivo3')} />
                    </div>
                    <div className="col-12 col-md-6">
                        <FormLabel htmlFor="archivo4" required={isTipoArchivoArbaVehiculo}>Archivo anexo de deudas</FormLabel>
                        <InputFile
                            name="archivo4"
                            type="text"
                            placeholder="Click para adjuntar un archivo..."
                            className={`form-control ${errorOf('archivo4') ? 'is-invalid' : ''}`}
                            value={file4?.name ?? ''}
                            onUpload={(name, data) => setFile4({ name, data })}
                        />
                        <FormError message={errorOf('archivo4')} />
                    </div>
                    </>
                    }
                </div>
            )}
            footer={<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={() => close()}>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={onAccept}>Aceptar</button>
            </>}
        />
    )
}

export default ImportadorModal
